export const VIEW_EVENT_FIELDCHANGE = 'fieldChange';
export const VIEW_EVENT_BUTTON = 'button';
export const VIEW_EVENT_INSERT = 'insertClick';
export const VIEW_EVENT_SHOWMENU = 'showMenu';
export const VIEW_EVENT_SHOWMENUHANDLE = 'showMenuHandle';
export const VIEW_EVENT_MENUCLICK = 'menuItemClick';
export const VIEW_EVENT_PEOPLE_ADDRESS = 'pplPickerSearchAddressBookClick';
export const VIEW_EVENT_PEOPLE_SEARCH = 'pplPickerCheckNamesClick';
export const VIEW_EVENT_PEOPLE_CHANGE = 'peoplePickerChange';
export const VIEW_EVENT_CUSTOM_SEARCH_CHANGE = 'peoplePickerSearchChange';
export const VIEW_EVENT_FILEDROP = 'fileDrop';
export const VIEW_EVENT_MULTISELECT = 'multiSelectCheck';
export const VIEW_EVENT_HYPERLINK_BOX_CLICK = 'hyperlinkBoxClick';
